import { getPath } from '@/router/common'

const baseUrl = {
  title: '货源大厅',
  path: 'ZXB'
}

export default [
  {
    path: getPath('Supply', baseUrl),
    name: 'ZXB_Supply',
    component: () => import(/* webpackChunkName: "ZXB_Supply" */ '@/views/zXB/supply/index.vue'),
    meta: {
      title: '货源大厅'
    }
  }
]
